import React from 'react';
import { UniversityInsights as UniversityInsightsComponent } from '../components/insights/UniversityInsights';

export const UniversityInsightsPage: React.FC = () => {
  return <UniversityInsightsComponent />;
};